module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_3009.0df70bb2.png";